import script from "./SMMA.vue?vue&type=script&lang=js"
export * from "./SMMA.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__